import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import DeleteAccount from "./DeleteAccount";

import RequestCompleteNotice from "../../../../common/settings-modal/RequestCompleteNotice";

import Image from "../../../../assets/img/chara-xxx-002.webp";

import { useAppSelector, useAppDispatch } from "../../../../redux/hooks";
import { getAuthToken, clearAuthInfo } from "../../../../redux/reducers/auth";
import { deleteUserAccount } from "../../../../redux/reducers/user";
import { sendEventTracking } from "../../../../utils/GeneralUtils";

type Props = { handleClose: () => void };

const DeleteAccountContainer: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const auth_token = useAppSelector(getAuthToken);
  const dispatch = useAppDispatch();

  const [isAgreement, setIsAgreement] = useState<boolean>(false);
  const [isComplete, setIsComplete] = useState<boolean>(false);

  const completeHandler = () => {
    navigate("/", { replace: true });
  };

  const handleSubmit = () => {
    if (auth_token && isAgreement) {
      setIsComplete(true);
      dispatch(deleteUserAccount(auth_token)).finally(() =>
        sendEventTracking("click", "deleteAccount", "delete")
      );
    }
  };

  useEffect(() => {
    return () => {
      if (isComplete) {
        dispatch(clearAuthInfo());
      }
    };
  }, [isComplete]);

  if (isComplete) {
    return (
      <RequestCompleteNotice
        handler={completeHandler}
        backBarText="アカウント削除完了"
        title="アカウント削除完了"
        text="アカウント削除が完了しました。 SELeCTのご利用ありがとうございました。"
        img={Image}
      />
    );
  } else {
    return (
      <DeleteAccount
        handleClose={handleClose}
        isAgreement={isAgreement}
        setIsAgreement={setIsAgreement}
        handleSubmit={handleSubmit}
      />
    );
  }
};

export default DeleteAccountContainer;
